/* eslint-disable no-use-before-define */
/* eslint-disable consistent-return, no-return-assign */
/* eslint no-param-reassign: ['error', {
  props: true,
  ignorePropertyModificationsFor: ['items']
}] */

function boolean(value) {
  if ([true, 'true'].includes(value)) return true;
  if ([false, 'false'].includes(value)) return false;

  return value;
}

function filled(value, extra) {
  const trimmed = typeof value === 'string' ? value.trim() : value;

  return ![null, undefined, '', extra].includes(trimmed);
}

export const TYPES = {
  RETURN: 'FinancingReturnRule',
  PRODUCT: 'FinancingProductRule',
};

export const UNALLOWED = {
  min_return: function min(ruleValue, value) {
    return (filled(ruleValue) && value < ruleValue) ? `Mínimo: ${ruleValue}` : undefined;
  },
  max_return: function max(ruleValue, value) {
    return (filled(ruleValue) && value > ruleValue) ? `Máximo: ${ruleValue}` : undefined;
  },
  include_financial_protection_insurance: function max(ruleValue, value) {
    return BOOLEAN_UNALLOWED(ruleValue, value);
  },
  include_asset_insurance: function max(ruleValue, value) {
    return BOOLEAN_UNALLOWED(ruleValue, value);
  },
  include_personal_insurance: function max(ruleValue, value) {
    return BOOLEAN_UNALLOWED(ruleValue, value);
  },
  include_capitalization_bond: function max(ruleValue, value) {
    return BOOLEAN_UNALLOWED(ruleValue, value);
  },
};

const RULES = {
  min_return: function min(items, returnRule, productRule, condition) {
    return GENERIC_RULE(items, returnRule, 'min_return', condition, 'credit_condition_return');
  },
  max_return: function max(items, returnRule, productRule, condition) {
    return GENERIC_RULE(items, returnRule, 'max_return', condition, 'credit_condition_return');
  },
  include_financial_protection_insurance: function max(items, returnRule, productRule, condition) {
    return BOOLEAN_RULE(items, productRule, condition, 'include_financial_protection_insurance');
  },
  include_asset_insurance: function max(items, returnRule, productRule, condition) {
    return BOOLEAN_RULE(items, productRule, condition.products_options, 'include_asset_insurance');
  },
  include_personal_insurance: function max(items, returnRule, productRule, condition) {
    return BOOLEAN_RULE(items, productRule, condition.products_options, 'include_personal_insurance');
  },
  include_capitalization_bond: function max(items, returnRule, productRule, condition) {
    return BOOLEAN_RULE(items, productRule, condition.products_options, 'include_capitalization_bond');
  },
};

function BOOLEAN_UNALLOWED(ruleValue, value) {
  const parsed = boolean(ruleValue);

  return (typeof parsed !== 'boolean' || !parsed || parsed === boolean(value)) ? undefined : 'Obrigatório';
}

function BOOLEAN_RULE(items, rule, object, property) {
  const result = UNALLOWED[property](rule && rule[property], object && object[property]);

  if (result) return (items[property] = result);
}

function GENERIC_RULE(items, rule, name, object, property) {
  const result = UNALLOWED[name](rule && rule[name], object && object[property]);

  if (result) return (items[property] = result);
}

export function findRuleIfEnabled(props, type, condition) {
  // eslint-disable-next-line no-underscore-dangle
  const typed = props.settings._enable_commercial_control_unallowed_tags
    ? props.rules.filter(rule => rule.object_type === type)
    : [];

  const found = undefined
    || typed.find(r => r.bank && r.bank.code === (condition.bank && condition.bank.febraban_code))
    || typed.find(r => !r.bank)
    || {};

  // if (found.id) {
  //   found.min_return = 2;
  //   found.max_return = 7;
  //   found.include_financial_protection_insurance = true;
  //   found.include_asset_insurance = true;
  //   found.include_personal_insurance = true;
  //   found.include_capitalization_bond = true;
  // }

  return found;
}

export function isUnallowed(object, condition) {
  return Object.values(object[condition.id]).some(i => i);
}

export default function unallowed(props, condition) {
  const items = {};
  const returnRule = findRuleIfEnabled(props, TYPES.RETURN, condition);
  const productRule = findRuleIfEnabled(props, TYPES.PRODUCT, condition);

  Object
    .keys(RULES)
    .forEach(name => RULES[name](items, returnRule, productRule, condition));

  return items;
}
